import { useState } from "react";
import { Visibility } from "@mui/icons-material";
import { Dialog, Grid, IconButton, Paper } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PdfPayPlanLayer from "@/PayPlans/views/Layers/Html/Sales/Associates";

const ViewPayPlanSelected = (props: { selectedPlan?: string; disabled?: boolean }) => {
	const { selectedPlan = "", disabled = false } = props;
	const [openPayPlanModel, setOpenPayPlanModel] = useState(false);

	const handleOpenPayPlanModel = () => {
		setOpenPayPlanModel(true);
	};

	return (
		<>
			<IconButton disabled={disabled} onClick={() => handleOpenPayPlanModel()} edge="end" sx={{ padding: "5px" }}>
				{<Visibility />}
			</IconButton>
			<Dialog
				open={openPayPlanModel}
				disableEscapeKeyDown
				onClose={() => {
					setOpenPayPlanModel(false);
				}}
				className="select-plan-dialog"
			>
				<Paper elevation={0} sx={{ padding: "35px 0px", height: "100%", borderRadius: "20px" }}>
					<Grid container className={"add-vertical-scroll-behavior"} sx={{ padding: "0 30px" }}>
						<IconButton
							onClick={() => {
								setOpenPayPlanModel(false);
							}}
							aria-label="close"
							sx={{
								position: "absolute",
								top: "10px",
								right: "10px",
							}}
						>
							<CloseIcon />
						</IconButton>
						<PdfPayPlanLayer selected={{ _id: selectedPlan }} />
					</Grid>
				</Paper>
			</Dialog>
		</>
	);
};

export default ViewPayPlanSelected;
